import { Injectable } from '@angular/core';
import { BehaviorSubject, map } from 'rxjs';

export const AUTH_TOKEN_STORAGE_KEY = 'noisy_user_token';
export const AUTH_EMAIL_STORAGE_KEY = 'noisy_user_email';
export const AUTH_USER_ID_STORAGE_KEY = 'noisy_user_id';

type AuthSessionState = {
  token: string | null;
  email: string | null;
  userId: number | null;
};

@Injectable({
  providedIn: 'root',
})
export class AuthSessionService {
  private readonly stateSubject = new BehaviorSubject<AuthSessionState>(this.loadState());
  readonly state$ = this.stateSubject.asObservable();
  readonly authenticated$ = this.state$.pipe(map((state) => Boolean(state.token)));

  getState(): AuthSessionState {
    return this.stateSubject.value;
  }

  isAuthenticated(): boolean {
    return Boolean(this.stateSubject.value.token);
  }

  setSession(token: string, email: string, userId: number): void {
    localStorage.setItem(AUTH_TOKEN_STORAGE_KEY, token);
    localStorage.setItem(AUTH_EMAIL_STORAGE_KEY, email);
    localStorage.setItem(AUTH_USER_ID_STORAGE_KEY, String(userId));
    this.stateSubject.next({ token, email, userId });
  }

  clearSession(): void {
    localStorage.removeItem(AUTH_TOKEN_STORAGE_KEY);
    localStorage.removeItem(AUTH_EMAIL_STORAGE_KEY);
    localStorage.removeItem(AUTH_USER_ID_STORAGE_KEY);
    this.stateSubject.next({ token: null, email: null, userId: null });
  }

  private loadState(): AuthSessionState {
    const token = localStorage.getItem(AUTH_TOKEN_STORAGE_KEY);
    const email = localStorage.getItem(AUTH_EMAIL_STORAGE_KEY);
    const rawUserId = localStorage.getItem(AUTH_USER_ID_STORAGE_KEY);
    const userId = rawUserId ? Number(rawUserId) : null;

    return {
      token,
      email,
      userId: Number.isFinite(userId) ? userId : null,
    };
  }
}
